import { applicationSettings } from '../application';
import { composeBoaGrid, uniformGrid } from '../settingsHelpers';
import { DIMENSIONS, ITEMS, MS, UNITS } from '../../constants';
const { width, height } = DIMENSIONS;

export default {
  grid: uniformGrid(10),
  dynamicGrid: composeBoaGrid(),
  defaultFilter: 'uprights',
  postWidth: 20,
  padHeight: 0,
  roomMinDesktop: {
    width: 4600,
    height: 3100,
  },
  roomMinSummary: {
    width: 1000,
    height: 1000,
  },
  roomMinMobile: {
    width: 2200,
    height: 2200,
  },
  distanceBetweenAttachments: 100,
  roomMax: {
    width: 5700,
    height: 3250,
  },
  zoomableScene: false,
  sideWall: true,
  wall: {
    width: {
      min: 1000,
      max: 5700,
    },
    height: {
      min: 1250,
      max: 3250,
    },
    points:
      applicationSettings.uiPlatform === 'kiosk'
        ? [
            { x: 0, y: 0 },
            { x: 4600, y: 0 },
            { x: 4600, y: 2400 },
            { x: 0, y: 2400 },
          ]
        : [
            { x: 0, y: 0 },
            { x: 4000, y: 0 },
            { x: 4000, y: 2650 },
            { x: 0, y: 2650 },
          ],
    pointsMobilePortrait: [
      { x: 0, y: 0 },
      { x: 2400, y: 0 },
      { x: 2400, y: 2650 },
      { x: 0, y: 2650 },
    ],
    pointsMobileLandscape: [
      { x: 0, y: 0 },
      { x: 5700, y: 0 },
      { x: 5700, y: 2650 },
      { x: 0, y: 2650 },
    ],
    pointsTablet: [
      { x: 0, y: 0 },
      { x: 3900, y: 0 },
      { x: 3900, y: 2650 },
      { x: 0, y: 2650 },
    ],
  },
  canvasMargins: { top: 50, right: 50 },
  canvasMarginsKiosk: { top: 50, right: 50 },
  canvasMarginsMobile: {
    top: 50,
    right: 50,
  },
  canvasMarginsPortraitPercentual: {
    mobile: 0.075,
    tablet: 0.05,
  },
  displaySectionMeasurements: true,
  displayTableMeasurements: true,
  /* TODO: Logic for automatic choice of mounting rails will be implemented in STOR2-3816.
           Until then, comment out the set of mounting rails that you don't want to use. */
  mountingRails: {
    white: {
      1800: '60474270',
      800: '10448740',
      600: '30448739',
    },
    anthracite: {
      1800: '00575597',
      800: '20575596',
      600: '70575594',
    },
  },
  measurements: {
    productsRemap: [],
    displayMeasurement: [
      {
        affects: [ITEMS.UPRIGHT],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: false,
          format: `${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [
          ITEMS.SHELF,
          ITEMS.METAL_SHELF,
          ITEMS.WIRE_SHELF,
          ITEMS.BASKET,
          ITEMS.CLOTHES_RAIL,
          ITEMS.TROUSER_HANGER,
          ITEMS.DRYING_RACK,
          ITEMS.SHOE_SHELF,
        ],
        rules: {
          measure: false,
          display: false,
          measurementPrefix: false,
          format: `${width} ${MS}`,
          unit: UNITS.cm,
        },
      },
    ],
  },
  hideInfoIconForType: [],
  bulkArticles: {},
  colorCodes: {
    white: '#F8F8F7',
    metal_white: '#F3F3F3',
    oak: '#D8B47E',
    wire_white: '#F8F8F7',
    black_brown: '#464541',
    anthracite: '#383E42',
    wire_anthracite: '#383E42',
    metal_anthracite: '#5F6367',
    grey: '#ABABAB',
    dark_grey: '#696766',
    light_blue: '#9BBBCB',
    white_stained_oak_effect: '#B6A189',
  },
  cuttableMountingRailProtrusionThreshold: 30,
  linkCardSkyttaImageFilename: 'link_card_skytta.jpg',
};
